import { CusasmComponent } from "./CusasmComponent";

export function CusasmScreen() {
  return (
    <>
      <CusasmComponent />
    </>
  );
}
